<template>
  <div class="locationpropertydetails">
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-layout row wrap>
          <v-flex
            v-for="field in visibleFields"
            xs12
            :key="`${field.id}`">
            <v-radio-group
              v-if="field.type === 'boolean'"
              v-validate="{ required: field.required }"
              :data-vv-name="field.name"
              :error="errors.collect(field.name).length > 0"
              :label="`${field.name}${field.required ? ' *' : ''}`"
              v-model="value[field.id]"
              :hint="field.description">
              <v-radio
                label="Yes"
                :value="'Yes'"></v-radio>
              <v-radio
                label="No"
                :value="'No'"></v-radio>
            </v-radio-group>
            <TextInputCommon
              v-model="value[field.id]"
              :display-name="`${field.name}`"
              :maxlength="125"
              :validations="{ required: field.required, max: 125}"
              :hint="field.description"
              :persistent-hint="true"
              v-if="field.type === 'text'"/>
            <NumberInputCommon
              v-model="value[field.id]"
              :display-name="`${field.name}`"
              :validations="{ required: field.required, numeric: true }"
              :maxlength="6"
              :hint="field.description"
              :persistent-hint="true"
              v-if="field.type === 'number'"/>
            <v-textarea
              v-model="value[field.id]"
              :maxlength="225"
              :counter="225"
              v-validate="{ required: field.required, max: 225 }"
              :error="errors.collect(field.name).length > 0"
              :label="`${field.name}${field.required ? ' *' : ''}`"
              :data-vv-name="field.name"
              :hint="field.description"
              :persistent-hint="true"
              v-if="field.type === 'textarea'"
              outline />
            <v-menu
              v-if="field.type === 'date'"
              v-model="dateMenus[`${field.id}`]"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{on}">
                <TextInputCommon
                  v-model="value.formattedDates[field.id]"
                  append-icon="event"
                  v-if="field.type === 'date'"
                  :error="errors.collect(field.id).length > 0"
                  :display-name="`${field.name}${field.required ? ' *' : ''}`"
                  @input="handleDateTextInput($event, field)"
                  :hint="field.description"
                  :persistent-hint="true"
                  v-on="on"/>
              </template>
              <v-date-picker
                v-model="value[field.id]"
                no-title
                @input="handleDatePicked($event, field)"></v-date-picker>
              </v-menu>
              <!-- Hidden text element to validate date-picker -->
              <TextInputCommon
                  v-model="value.formattedDates[field.id]"
                  append-icon="event"
                  v-show="false"
                  :validations="{ required: field.required, date_format: 'MM-dd-yyyy' }"
                  :data-vv-name="field.id"
                  :identifier="field.id"
                  v-if="field.type === 'date'"
                  :display-name="field.name"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Constants } from '@spectorasoftware/homegauge-vue';
import Moment from 'moment';
import NumberInputCommon from '@/components/common/NumberInputCommon.vue';
import TextInputCommon from '@/components/common/TextInputCommon.vue';

const { InputValidations } = Constants;

const DEFAULT_MODEL = {
  formattedDates: {},
};

export default {
  components: {
    NumberInputCommon,
    TextInputCommon,
  },
  inject: ['$validator'],
  props: {
    value: {
      type: Object,
      default: () => DEFAULT_MODEL,
    },
    customFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      InputValidations,
      dateMenus: {},
      formattedDates: {},
    };
  },
  mounted() {
    this.dateMenus = this.visibleFields.reduce((acc, field) => {
      if (field.type === 'date') {
        acc[field.id] = false;
      }
      return acc;
    }, {});
    this.value.formattedDates = this.visibleFields.reduce((acc, field) => {
      if (field.type === 'date') {
        acc[field.id] = this.value[field.id] ? Moment(this.value[field.id]).format('MM-DD-YYYY') : '';
      }
      return acc;
    }, {});
  },
  methods: {
    handleDatePicked(date, field) {
      this.value[field.id] = date;
      this.dateMenus[field.id] = false;
      this.value.formattedDates[field.id] = Moment(date).format('MM-DD-YYYY');
    },
    handleDateTextInput(value, field) {
      if (!value) {
        this.value[field.id] = null;
      }
    },
  },
  computed: {
    visibleFields() {
      return this.customFields.filter(field => field.displayStatus === 'visible' && !field.internal);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/typography';

small {
  display: block;
  font-size: 0.85rem;
  font-weight: $typography-weight-semibold;
  line-height: 1.6;
}

.v-input--selection-controls {
  margin: 0;
}

.locationpropertydetails {
  &--subheading {
    letter-spacing: 0.1rem;
  }
}
</style>
